"use client";

import { c as _c } from "react/compiler-runtime";
import { FallbackImage } from "@/components/common/FallbackImage";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import useKeyPressEvent from "react-use/lib/useKeyPressEvent";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { ExpandedMediaToolbar } from "./MediaActionToolbar";
export function requestCenteredImageFullscreen(fullscreenTarget: HTMLImageElement) {
  const previousObjectPosition = fullscreenTarget.style.objectPosition;
  fullscreenTarget.style.objectPosition = "center";
  const restoreInlinePosition = () => {
    if (document.fullscreenElement === fullscreenTarget) {
      return;
    }
    fullscreenTarget.style.objectPosition = previousObjectPosition;
    document.removeEventListener("fullscreenchange", restoreInlinePosition);
  };
  document.addEventListener("fullscreenchange", restoreInlinePosition);
  fullscreenTarget.requestFullscreen().catch(() => {
    document.removeEventListener("fullscreenchange", restoreInlinePosition);
    fullscreenTarget.style.objectPosition = previousObjectPosition;
  });
}
export function ImageMediaModal(t0) {
  const $ = _c(26);
  const {
    src,
    imageRef,
    onClose,
    onOpen,
    openLabel,
    onDownload,
    isDownloading,
    onFullscreen,
    fullscreenTargetAvailable: t1
  } = t0;
  const fullscreenTargetAvailable = t1 === undefined ? true : t1;
  const [isZoomed, setIsZoomed] = useState(false);
  useKeyPressEvent("Escape", onClose);
  const isPointInsideRenderedImage = _temp;
  let t2;
  if ($[0] !== imageRef || $[1] !== onClose) {
    t2 = event => {
      event.stopPropagation();
      const image_0 = imageRef.current;
      if (!image_0 || event.detail === 0) {
        onClose();
        return;
      }
      if (!isPointInsideRenderedImage(image_0, event.clientX, event.clientY)) {
        onClose();
      }
    };
    $[0] = imageRef;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleExpandedImageButtonClick = t2;
  let t3;
  if ($[3] !== onClose) {
    t3 = <button type="button" aria-label="Close modal" data-testid="modal-backdrop" onClick={onClose} className="tw-fixed tw-inset-0 tw-z-1000 tw-border-0 tw-bg-black/80 tw-p-0" />;
    $[3] = onClose;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      disabled: true
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !isZoomed;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = event_3 => setIsZoomed(event_3.state.scale > 1);
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== handleExpandedImageButtonClick || $[8] !== imageRef || $[9] !== src) {
    t7 = () => <div className="tw-pointer-events-none tw-fixed tw-inset-0 tw-z-[1001] tw-flex tw-items-center tw-justify-center tw-overflow-hidden"><div className="tw-pointer-events-auto tw-relative tw-flex tw-h-[90dvh] tw-w-[95vw] tw-flex-col"><div className="tw-flex tw-min-h-0 tw-min-w-0 tw-flex-1 tw-flex-col tw-items-center tw-justify-center"><TransformComponent wrapperClass="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center" contentClass="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center" wrapperStyle={{
            width: "95vw",
            height: "90dvh"
          }} contentStyle={{
            width: "95vw",
            height: "90dvh"
          }}><button type="button" aria-label="Close modal" className="tw-relative tw-h-full tw-w-full tw-border-0 tw-bg-transparent tw-p-0" onClick={handleExpandedImageButtonClick}><FallbackImage ref={imageRef} primarySrc={src} fallbackSrc={src} alt="Full size drop media" fill={true} sizes="95vw" optimize={false} style={{
                objectFit: "contain",
                objectPosition: "center",
                pointerEvents: "auto"
              }} /></button></TransformComponent></div></div></div>;
    $[7] = handleExpandedImageButtonClick;
    $[8] = imageRef;
    $[9] = src;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t7) {
    t8 = <TransformWrapper panning={t4} limitToBounds={t5} smooth={true} onZoom={t6}>{t7}</TransformWrapper>;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== fullscreenTargetAvailable || $[15] !== isDownloading || $[16] !== onClose || $[17] !== onDownload || $[18] !== onFullscreen || $[19] !== onOpen || $[20] !== openLabel) {
    t9 = <ExpandedMediaToolbar onOpen={onOpen} openLabel={openLabel} onDownload={onDownload} isDownloading={isDownloading} onFullscreen={onFullscreen} fullscreenTargetAvailable={fullscreenTargetAvailable} onClose={onClose} />;
    $[14] = fullscreenTargetAvailable;
    $[15] = isDownloading;
    $[16] = onClose;
    $[17] = onDownload;
    $[18] = onFullscreen;
    $[19] = onOpen;
    $[20] = openLabel;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t3 || $[23] !== t8 || $[24] !== t9) {
    t10 = createPortal(<div className="tailwind-scope tw-relative tw-z-1000 tw-cursor-default" onTouchStart={_temp2} onTouchEnd={_temp3} onTouchMove={_temp4}>{t3}{t8}{t9}</div>, document.body);
    $[22] = t3;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
function _temp4(event_2) {
  return event_2.stopPropagation();
}
function _temp3(event_1) {
  return event_1.stopPropagation();
}
function _temp2(event_0) {
  return event_0.stopPropagation();
}
function _temp(image, clientX, clientY) {
  const rect = image.getBoundingClientRect();
  const naturalWidth = image.naturalWidth;
  const naturalHeight = image.naturalHeight;
  if (rect.width <= 0 || rect.height <= 0 || naturalWidth <= 0 || naturalHeight <= 0) {
    return true;
  }
  const imageAspectRatio = naturalWidth / naturalHeight;
  const containerAspectRatio = rect.width / rect.height;
  const renderedWidth = imageAspectRatio > containerAspectRatio ? rect.width : rect.height * imageAspectRatio;
  const renderedHeight = imageAspectRatio > containerAspectRatio ? rect.width / imageAspectRatio : rect.height;
  const renderedLeft = rect.left + (rect.width - renderedWidth) / 2;
  const renderedTop = rect.top + (rect.height - renderedHeight) / 2;
  return clientX >= renderedLeft && clientX <= renderedLeft + renderedWidth && clientY >= renderedTop && clientY <= renderedTop + renderedHeight;
}